export const TRACK = 'CS/TRACK';
export const TRACK_DONUT_CLICK = `${TRACK}_DONUT_CLICK`;
export const TRACK_CLICKABLE_HELP_CLICK = `${TRACK}_CLICKABLE_HELP_CLICK`;
export const TRACK_PRODUCT_TOGGLE_CLICK = `${TRACK}_PRODUCT_TOGGLE_CLICK`;
export const TRACK_PREAPPROVED_TOGGLE_CLICK = `${TRACK}_PREAPPROVED_TOGGLE_CLICK`;
export const TRACK_PRODUCT_NAVIGATION_CLICK = `${TRACK}_PRODUCT_NAVIGATION_CLICK`;
export const TRACK_REPORT_ACCOUNT_DETAILS_OPEN = `${TRACK}_REPORT_ACCOUNT_DETAILS_OPEN`;
export const TRACK_REPORT_ACCOUNT_DETAILS_CLICK = `${TRACK}_REPORT_ACCOUNT_DETAILS_CLICK`;
export const TRACK_REPORT_ACCOUNT_PAYMENT_HISTORY_CLICK = `${TRACK}_REPORT_ACCOUNT_PAYMENT_HISTORY_CLICK`;
export const TRACK_DOC_UPLOAD_ATTEMPT = `${TRACK}_DOC_UPLOAD_ATTEMPT`;
export const TRACK_DYNAMIC_FORMS_GO_BACK = `${TRACK}_DYNAMIC_FORMS_GO_BACK`;
export const TRACK_DYNAMIC_FORMS_START_ERROR = `${TRACK}_DYNAMIC_FORMS_START_ERROR`;
export const TRACK_DYNAMIC_FORMS_NEXT_ERROR = `${TRACK}_DYNAMIC_FORMS_NEXT_ERROR`;
export const TRACK_DUPLOCK_CTA_CLICK = `${TRACK}_DUPLOCK_CTA_CLICK`;
export const TRACK_MANUAL_ADDRESS_ENTRY_CLICK = `${TRACK}_MANUAL_ADDRESS_ENTRY_CLICK`;
export const TRACK_PRODUCT_INTERSTITIAL_PROGRESSION = `${TRACK}_PRODUCT_INTERSTITIAL_PROGRESSION`;
export const TRACK_PRODUCT_INTERSTITIAL_COPY_CTA_CLICK = `${TRACK}_PRODUCT_INTERSTITIAL_COPY_CTA_CLICK`;
export const TRACK_PRODUCT_FILTER_APPLIED = `${TRACK}_PRODUCT_FILTER_APPLIED`;
export const TRACK_PRODUCT_FILTER_CLICK = `${TRACK}_PRODUCT_FILTER_CLICK`;
export const TRACK_PRODUCT_FILTER_UPDATED = `${TRACK}_PRODUCT_FILTER_UPDATED`;
export const TRACK_DONUT_SLIDE_VIEWED = `${TRACK}_DONUT_SLIDE_VIEWED`;
export const TRACK_DYNAMIC_DASHBOARD_DONUT_CLICKED = `${TRACK}_DYNAMIC_DASHBOARD_DONUT_CLICKED`;
export const TRACK_GLOBAL_ALERT_RENDERED = `${TRACK}_GLOBAL_ALERT_RENDERED`;
export const TRACK_GLOBAL_ALERT_CTA_CLICKED = `${TRACK}_GLOBAL_ALERT_CTA_CLICKED`;
export const TRACK_GLOBAL_ALERT_CLOSED = `${TRACK}_GLOBAL_ALERT_CLOSED`;
export const TRACK_IDENTIFY_REGISTRATION = `${TRACK}_IDENTIFY_REGISTRATION`;
export const TRACK_MOBILE_APP_BANNER_VIEWED = `${TRACK}_MOBILE_APP_BANNER_VIEWED`;
export const TRACK_MOBILE_APP_BANNER_DISMISSED = `${TRACK}_MOBILE_APP_BANNER_DISMISSED`;
export const TRACK_MOBILE_APP_BANNER_CLICKED = `${TRACK}_MOBILE_APP_BANNER_CLICKED`;
